import React from 'react'
import {ga} from 'shared'

import {createBrowserHistory} from 'history'
const history = createBrowserHistory()

import {
  ContentHeader,
  Detail,
  Overview,
  Bounds,
} from 'discover'

import { QueryHelper } from 'shared'

export class Page extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      bounds:       null,
      categoryId:   props.initialTeaser && props.initialTeaser.id,
      searchQuery:  null,
      projectCount: 0,
    }
  }

  componentDidMount() {
    if (!this.props.initialTeaser) {
      this.adaptToQuery()
    }

    history.listen((_, action) => {
      if (action === 'POP') this.adaptToQuery()
    })
  }

  sendGaTracking = (searchQuery, categoryId, bounds) => {
    let location     = window.location,
        trackingPath = location.pathname + location.search + location.hash,
        dimension5   = '/discover-projects/'
    dimension5 += `searchQuery:${ searchQuery ? 'on' : 'off' }/`
    dimension5 += `category:${ categoryId ? 'on' : 'off' }/`
    dimension5 += `bounds:${ bounds ? 'on' : 'off' }/`
    ga('send', 'pageview', trackingPath, { dimension5: dimension5 })
    this.setState({ ga_dimension5: dimension5 })
  }

  adaptToQuery() {
    const queryParams = QueryHelper.parseQuery(),
          categoryId  = queryParams.categoryId,
          bounds      = Bounds.fromParams(queryParams.bounds, queryParams.boundsLabel),
          searchQuery = queryParams.q
    this.setState({
      categoryId:  categoryId,
      bounds:      bounds,
      searchQuery: searchQuery,
    })

    this.sendGaTracking(searchQuery, categoryId, bounds)
  }

  searchQueryChanged = (searchQuery) => {
    this.setState({ searchQuery: searchQuery })
    this.pushHistory(this.state.categoryId, this.state.bounds, searchQuery)
  }

  categoryChanged = (categoryId) => {
    this.setState({ categoryId: categoryId })
    this.pushHistory(categoryId, this.state.bounds, this.state.searchQuery)
  }

  boundsChanged = (bounds) => {
    this.setState({ bounds: bounds })
    this.pushHistory(this.state.categoryId, bounds, this.state.searchQuery)
  }

  setProjectCount = (count) => {
    this.setState({ projectCount: count })
  }

  pushHistory(categoryId, bounds, searchQuery) {
    if (bounds) bounds = bounds.toParams()
    const query = QueryHelper.toQuery({ q: searchQuery, categoryId: categoryId, bounds: bounds })

    const pathnameWithoutPermalink = window.location.pathname.replace(/\/\d.*/, '')

    history.push({ pathname: pathnameWithoutPermalink, search: query })
    this.sendGaTracking(searchQuery, categoryId, bounds)
  }

  get activeTeaser() {
    if (!this.state.categoryId) return null
    for (let category of this.props.categories) {
      if (category.id == this.state.categoryId) return category
    }
  }

  get isOverview() {
    const {bounds, categoryId, searchQuery} = this.state
    return !(bounds || categoryId || searchQuery)
  }

  render() {
    const Content = this.isOverview ? Overview : Detail

    return (
      <div>
        <ContentHeader
          defaultImageUrl={ this.props.defaultHeaderImageUrl }
          category={ this.activeTeaser }
        />

        <div className='content-wrapper'>
          <Content
            { ...this.props }
            bounds={ this.state.bounds }
            boundsChanged={ this.boundsChanged }
            categoryChanged={ this.categoryChanged }
            searchQuery={ this.state.searchQuery }
            searchQueryChanged={ this.searchQueryChanged }
            categoryId={ this.state.categoryId }
            projectCount={ this.state.projectCount }
            setProjectCount={ this.setProjectCount }
            category={ this.activeTeaser }
            gtmList={ this.state.ga_dimension5}
          />
        </div>
      </div>
    )
  }
}
